export type downloadFileFn = (href: string, filename: string) => void;

export const downloadFile = (href: string, filename: string): void => {
  const link = document.createElement('a');
  link.setAttribute('href', href);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const base64DownloadXlsx = (
  base64Data: string,
  filename: string,
  downloadFn: downloadFileFn
): void => {
  // Decode base64 to binary string
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const encodedUri = URL.createObjectURL(blob);
  downloadFn(encodedUri, filename.split('.')[0]);
};

export default downloadFile;
